<div class="modal-content">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4 class="mb-0">Wants Alerts</h4>
    </div>
    <button
      type="button"
      class="close-btn float-end"
      aria-label="Close"
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-0 pt-3">
    <form [formGroup]="inventory_options_form" (ngSubmit)="submitClick()">
      <!-- Item Info Row -->
      @if (modal_type === "Add") {
        <div class="row align-items-center mb-4 px-2">
          <label class="col-sm-2 col-form-label text-light text-end"
            >UPC:</label
          >
          <div class="col-sm-4 d-flex gap-2">
            <input
              type="text"
              class="form-control modern-input flex-grow-1"
              style="width: auto"
              formControlName="item_upc"
            />
            <button
              type="button"
              class="btn modern-btn primary-btn d-flex align-items-center"
              (click)="searchItem()"
            >
              Search
            </button>
          </div>
          <label class="col-sm-2 col-form-label text-light text-end"
            >Model:</label
          >
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control modern-input w-100 text-dark"
              formControlName="item_name"
            />
          </div>
          <label class="col-sm-2 col-form-label text-light text-end mt-3"
            >Description:</label
          >
          <div class="col-sm-10 mt-3">
            <input
              type="text"
              class="form-control modern-input w-100 text-dark"
              formControlName="item_description"
            />
          </div>
        </div>
      } @else {
        <div class="row align-items-center mb-4 px-2">
          <div class="col-12 d-flex flex-wrap gap-4 text-light">
            <span
              ><span class="bold">Item:</span>
              <span class="text-light ms-1">{{ item_name }}</span></span
            >
            <span
              ><span class="bold">Description:</span>
              <span class="text-light ms-1">{{ item_description }}</span></span
            >
            <span
              ><span class="bold">UPC:</span>
              <span class="text-light ms-1">{{ item_upc }}</span></span
            >
          </div>
        </div>
      }

      <!-- Active Alerts -->
      @if (
        request_type === "alert" ||
        alert_selected_row?.alert_selected_vendors?.length > 0
      ) {
        <hr class="divider-modern mb-4" />
        <h5 class="mb-3 px-2 text-light">In-stock Alert</h5>

        <!-- Selected Vendors -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="alert_selected_vendors"
            class="col-sm-3 col-form-label form-label text-end mb-0"
            >Vendors:</label
          >
          <div class="col-sm-6">
            <ng-select
              [items]="filteredVendors"
              [multiple]="true"
              [closeOnSelect]="true"
              bindLabel="contact.display_name"
              class="form-control modern-input w-100 p-0 border-0 bg-transparent"
              formControlName="alert_selected_vendors"
              (change)="alertSetRequiredFields()"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear" let-itemLabel="itemLabel">
                <span class="ng-value-label">
                  {{ itemLabel || item?.contact?.display_name || item['contact.display_name'] || item?.contact?.company_name || item }}
                </span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-itemLabel="itemLabel">
                {{ itemLabel || item?.contact?.display_name || item['contact.display_name'] || item?.contact?.company_name || item }}
              </ng-template>
            </ng-select>
          </div>
        </div>


        <!-- Desired Qty -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="alert_desired_qty"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
            <span class="required text-danger me-1">*</span>Desired Qty:
          </label>
          <div class="col-sm-3">
            <input
              type="number"
              class="form-control modern-input w-100"
              formControlName="alert_desired_qty"
              id="alert_desired_qty"
              (change)="checkForNegative($event)"
            />
          </div>
        </div>

        <!-- Alert Text Number -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="alert_text_number"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
             <span class="required text-danger me-1">*</span>Text Phone Number:
          </label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control modern-input w-100"
              formControlName="alert_text_number"
              id="alert_text_number"
            />
          </div>
        </div>

        <!-- Alert Email -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="alert_email"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
             <span class="required text-danger me-1">*</span>Alert Email:
          </label>
          <div class="col-sm-6">
            <input
              type="email"
              class="form-control modern-input w-100"
              formControlName="alert_email"
              id="alert_email"
            />
          </div>
        </div>
        <!-- Requestor -->
        <div class="row mb-3 align-items-center px-2">
          <label class="col-sm-3 col-form-label text-light text-end">
            <span class="required text-danger me-1">*</span>Requestor:
          </label>
          <div class="col-sm-6 d-flex align-items-end">
            <ng-select
              [items]="accountingService.customers"
              [multiple]="false"
              bindLabel="contact.display_name"
              bindValue="contact.display_name"
              class="form-control modern-input w-100 p-0 border-0 bg-transparent joined-select"
              formControlName="requestor"
            >
              <ng-template ng-option-tmp let-item="item">
                <div [title]="item?.contact?.display_name || ''">
                  {{ item?.contact?.display_name }}
                  <span
                    style="font-size: smaller; color: rgba(255, 255, 255, 0.4)"
                  >
                    {{
                      item?.contact?.phone_number
                        ? formatPhoneNumber(item.contact.phone_number)
                        : ""
                    }}
                    {{ item?.contact?.email ? " | " + item.contact.email : "" }}
                  </span>
                </div>
              </ng-template>
            </ng-select>
            <div class="button-between">
              @if (!inventory_options_form.get("requestor").value) {
                <button
                  type="button"
                  class="btn btn-primary add-button"
                  (click)="addNewCustomer()"
                  tooltip="Add Customer"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              }
              @if (inventory_options_form.get("requestor").value) {
                <button
                  type="button"
                  class="btn btn-warning edit-button"
                  (click)="editCustomer()"
                  tooltip="Edit Customer"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              }
            </div>
          </div>
        </div>
      }

      <!-- Auto Purchases -->
      @if (
        request_type === "auto_purchase" ||
        auto_purchase_selected_row?.auto_purchase_selected_vendors?.length > 0
      ) {
        <hr class="divider-modern mt-2 mb-4" />
        <h5 class="mb-3 px-2 text-light">Auto Purchase</h5>

        <!-- Selected Vendors -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="auto_purchase_vendors"
            class="col-sm-3 col-form-label form-label text-end mb-0"
            >Vendors:</label
          >
          <div class="col-sm-9">
            <ng-select
              [items]="filteredVendors"
              [multiple]="true"
              [closeOnSelect]="true"
              bindLabel="contact.display_name"
              appendTo="body"
              class="form-control modern-input w-100 p-0 border-0 bg-transparent"
              formControlName="auto_purchase_vendors"
              (change)="autoPurchaseSetRequiredFields()"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear" let-itemLabel="itemLabel">
                <span class="ng-value-label">
                  {{ itemLabel || item?.contact?.display_name || item['contact.display_name'] || item?.contact?.company_name || item }}
                </span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-itemLabel="itemLabel">
                {{ itemLabel || item?.contact?.display_name || item['contact.display_name'] || item?.contact?.company_name || item }}
              </ng-template>
            </ng-select>
          </div>
        </div>

        <!-- Desired Qty -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="auto_purchase_qty"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
            <span class="required text-danger me-1">*</span>Desired Qty:
          </label>
          <div class="col-sm-3">
            <input
              type="number"
              class="form-control modern-input w-100"
              formControlName="auto_purchase_qty"
              id="auto_purchase_qty"
              (change)="checkForNegative($event)"
            />
          </div>
        </div>

        <!-- Date Range for Purchase -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="auto_purchase_date_range"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
            <span class="required text-danger me-1">*</span>Date Range:
          </label>
          <div class="col-sm-9">
            <input
              #date_acquired
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="auto_purchase_date_range"
              id="auto_purchase_date_range"
              placeholder="__/__/__ __:__ - __/__/__ __:__"
              [bsConfig]="bsConfig"
              [readOnly]="false"
              bsDaterangepicker
              autocomplete="off"
            />
          </div>
        </div>

        <!-- Partial Qty Okay -->
        <div class="row mb-3 align-items-center px-2">
          <label
            for="auto_purchase_partial_orders"
            class="col-sm-3 col-form-label form-label text-end mb-0"
          >
            Partial Qty Allowed:
          </label>
          <div class="col-sm-9">
            <div class="form-check d-flex align-items-center mt-1">
              <input
                class="form-check-input modern-checkbox me-2"
                type="checkbox"
                value=""
                id="auto_purchase_partial_orders"
                formControlName="auto_purchase_partial_orders"
              />
              <label
                class="form-check-label text-light"
                for="auto_purchase_partial_orders"
              >
                Check if partial orders are allowed.
              </label>
            </div>
          </div>
        </div>
      }

      <!-- Auto Purchases Requestor -->
      @if (
        request_type === "auto_purchase" ||
        auto_purchase_selected_row?.auto_purchase_selected_vendors?.length > 0
      ) {
        <div class="row mb-3 align-items-center px-2">
          <label class="col-sm-3 col-form-label text-light text-end">
            <span class="required text-danger me-1">*</span>Requestor:
          </label>
          <div class="col-sm-6 d-flex align-items-end">
            <ng-select
              [items]="accountingService.customers"
              [multiple]="false"
              bindLabel="contact.display_name"
              bindValue="contact.display_name"
              appendTo="body"
              class="form-control modern-input w-100 p-0 border-0 bg-transparent joined-select"
              formControlName="requestor"
            >
              <ng-template ng-option-tmp let-item="item">
                <div [title]="item?.contact?.display_name || ''">
                  {{ item?.contact?.display_name }}
                  <span
                    style="font-size: smaller; color: rgba(255, 255, 255, 0.4)"
                  >
                    {{
                      item?.contact?.phone_number
                        ? formatPhoneNumber(item.contact.phone_number)
                        : ""
                    }}
                    {{ item?.contact?.email ? " | " + item.contact.email : "" }}
                  </span>
                </div>
              </ng-template>
            </ng-select>
            <div class="button-between">
              @if (!inventory_options_form.get("requestor").value) {
                <button
                  type="button"
                  class="btn btn-primary add-button"
                  (click)="addNewCustomer()"
                  tooltip="Add Customer"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              }
              @if (inventory_options_form.get("requestor").value) {
                <button
                  type="button"
                  class="btn btn-warning edit-button"
                  (click)="editCustomer()"
                  tooltip="Edit Customer"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              }
            </div>
          </div>
        </div>
      }

      <!-- Legend -->
      <div class="row mt-4 px-2">
        <div class="col-12 px-2 text-start small">
          <span class="text-danger">*</span>
          <span class="text-light"> Denotes required fields</span>
        </div>
      </div>

      <!-- Buttons -->
      <div
        class="modal-footer border-top-0 d-flex justify-content-between mt-4 px-0 pt-0"
      >
        <button
          type="button"
          class="btn modern-btn secondary-btn px-4"
          (click)="closeModalClick()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn modern-btn primary-btn px-4"
          [disabled]="
            inventory_options_form.invalid ||
            ((inventory_options_form.get('alert_selected_vendors').value ===
              null ||
              inventory_options_form.get('alert_selected_vendors').value
                .length === 0) &&
              (inventory_options_form.get('auto_purchase_vendors').value ===
                null ||
                inventory_options_form.get('auto_purchase_vendors').value
                  .length === 0) &&
              modal_type !== 'Add')
          "
        >
          @if (alert_selected_row?.alert_selected_vendors?.length > 0) {
            <span>Edit Alert</span>
          } @else if (
            auto_purchase_selected_row?.auto_purchase_selected_vendors?.length >
            0
          ) {
            <span>Edit Auto-Purchase</span>
          } @else {
            <span>Submit Request</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>

